import * as React from 'react';
import { connect } from 'react-redux';
import { find } from 'lodash';
import * as minuteDiff from 'minute-diff';
import {
  Async,
  Title,
  IconButton,
  NoteList,
  RouteWrapper,
  AccessoryUpdateForm,
  Permission,
} from '../../components';
import { getAccessory } from '../../redux/actions/accessories';

interface Props {
  accessories: any;
  match: any;
  dispatch: Function;
}

interface State {
  id: number;
  accessory: any;
  ready: boolean;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    const id = parseInt(this.props.match.params.id, 10);
    this.state = {
      id,
      accessory: find(this.props.accessories.accessories, { id }) || false,
      ready: false,
    };
    this.renderHeading = this.renderHeading.bind(this);
    this.renderDelete = this.renderDelete.bind(this);
    this.renderBody = this.renderBody.bind(this);
  }

  componentDidMount() {
    const onReady = () => {
      this.setState({ ready: true });
    };
    if (
      !this.state.accessory.lastUpdated ||
      minuteDiff(this.state.accessory.lastUpdated) >= 1
    ) {
      this.props.dispatch(getAccessory(this.state.id)).then((response) => {
        this.setState({ accessory: response.data });
        onReady();
      });
    } else {
      onReady();
    }
  }

  renderHeading() {
    return (
      <div className="level-left">
        {this.state.accessory.image && (
          <span className="avatar image is-64x64">
            <img
              src={this.state.accessory.image}
              alt={this.state.accessory.name}
            />
          </span>
        )}
        <Async on={this.state.ready}>
          <Title>{this.state.accessory.name || 'Unknown Accessory'}</Title>
        </Async>
      </div>
    );
  }

  renderDelete() {
    return (
      <Permission require="MANAGE_DELETIONS">
        <div className="level-right">
          <IconButton
            link={`/settings/accessories/${this.state.id}/delete`}
            className="is-danger"
            icon="trash"
          >
            Delete
          </IconButton>
        </div>
      </Permission>
    );
  }

  renderBody() {
    if (this.state.ready) {
      return (
        <AccessoryUpdateForm
          id={this.state.id}
          item={this.state.accessory}
          onUpdate={() => {
            window.history.back();
          }}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <RouteWrapper
        title={this.state.accessory.name || 'Unknown Accessory'}
        requireAuth
        requirePermission="MANAGE_ACCESSORIES"
        breadcrumbs={[
          { link: '/settings', text: 'Settings' },
          { link: '/settings/accessories', text: 'Accessories' },
          {
            link: '/settings/accessories/:id',
            text: this.state.accessory.name || 'Accessory',
          },
        ]}
        loading={this.props.accessories.isFetching}
        error={!this.state.ready && this.props.accessories.error}
      >
        <div className="container">
          <div className="columns is-multiline">
            <div className="column is-12-desktop is-7-widescreen">
              <div className="level">
                {this.renderHeading()}
                {this.renderDelete()}
              </div>
              {this.renderBody()}
            </div>
            <div className="column is-12-desktop is-5-widescreen">
              <NoteList resource="accessories" id={this.state.id} />
            </div>
          </div>
        </div>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ accessories }) => ({
  accessories,
});

export default connect(mapStateToProps)(Route);
